const userInfo = () => {
    return JSON.parse(window.localStorage.getItem('userInfo'));
};

const getters = {
    token: function(state) {
        if (state.user.token != '') {
            return state.user.token;
        }
        try {
            if(window.localStorage && window.localStorage.getItem('userToken')) {
                return window.localStorage.getItem('userToken');
            }
            return '';
        } catch (err) {
            return null;
        }
    },
    account: function(state) {
        if (state.user.account && state.user.account != '' && state.user.account != "undefined") {
            return state.user.account;
        }
        try {
            if(window.localStorage) {
                let val = window.localStorage.getItem('userAccount');
                return (val && val != "undefined") ? val : '';
            }
            return '';
        } catch (err) {
            return null;
        }
    },
    expire_time: function(state) {
        if (state.user.expire_time && state.user.expire_time != "undefined") {
            return state.user.expire_time;
        }
        try {
            if(window.localStorage) {
                let val = window.localStorage.getItem('expireTime');
                return (val && val != "undefined") ? val : '';
            }
            return '';
        } catch (err) {
            return null;
        }
    },
    username: function(state) {
        if (state.user.username != '') {
            return state.user.username;
        }
        try {
            return userInfo().info.username;
        } catch (err) {
            return null;
        }
    },
    lottery_config: function(state) {
        return state.lottery.items;
    },
    lottery_all: function(state) {
        return state.lottery.all;
    },
    sound_status: function(state) {
        return state.user.sound;        
    },
    invitation_code: function(state) {
        return state.user.invitation_code;        
    }
};
export default getters;


// WEBPACK FOOTER //
// ./src/store/getters.js